import React from 'react';
import { Button, Grid, Header } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import FileConfiguration from '../containers/FileConfiguration';
import { TitledCard, DatePickerCustomButton } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { IMPORT_ITEMS_FORM_NAME } from 'Common/FormEnum';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import {
  DatePickerField,
  InputField,
  SelectField,
} from 'Common/SemanticWrapper';
import { ImportExportTypeOptionsEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ApiResultMessage } from 'Components';
import ImportFilePreview from './../containers/ImportFilePreview';
import {
  importExportTypeOptions,
  yesNoOptions,
} from './../../../helper/importExport';

const filterHeaderFields = data => {
  return data.map(d => {
    return {
      [ImportExportItemsEnum.FieldName]: d[ImportExportItemsEnum.FieldName],
      [ImportExportItemsEnum.ColumnNumber]:
        d[ImportExportItemsEnum.ColumnNumber],
    };
  });
};
const ImportItemsComponent = props => {
  const {
    handleSubmit,
    onChangeImportType,
    onChangeConfig,
    importType,
    importBidPrice,
    onChangeOfFromDT,
    onChangeOfToDT,
    toDateMin,
    importItemsErrors,
    importItemsData,
    columnMapping,
    loadPreviousImportOptionsDropDown,
    fromDateMax,
    handleFilePreview,
    columns,
    updatePreviewData,
    clearMappingHandler,
    uploadAnotherFileBtnClick,
    onChangeOfBidPrice,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Grid>
        <Grid.Row className="row--compressed" columns={2}>
          <Grid.Column>
            <TitledCard title={'Save/Load Settings'} style={{ minHeight: 280 }}>
              <Grid style={{ minHeight: 197 }}>
                <Grid.Row>
                  <Grid.Column>
                    <div>
                      <label>What Type of import is this?</label>
                      <ReduxFormButtonGroup
                        options={importExportTypeOptions}
                        type={'button'}
                        formName={IMPORT_ITEMS_FORM_NAME}
                        fieldName={ImportExportItemsEnum.Type}
                        onChange={onChangeImportType}
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    {importType ===
                      ImportExportTypeOptionsEnum.LoadPreviouslySaved && (
                      <Field
                        name={ImportExportItemsEnum.LoadPrevious}
                        component={SelectField}
                        type={'text'}
                        options={loadPreviousImportOptionsDropDown}
                        label={'Please select a saved configuration'}
                        onChange={onChangeConfig}
                      />
                    )}
                    {importType === ImportExportTypeOptionsEnum.New && (
                      <Field
                        name={ImportExportItemsEnum.Name}
                        component={InputField}
                        type={'text'}
                        label={'Name of configuration to be saved'}
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Grid.Column>
          <Grid.Column>
            <TitledCard title={'Bid Prices'} style={{ minHeight: 280 }}>
              <Grid style={{ minHeight: 197 }}>
                <Grid.Row>
                  <Grid.Column>
                    <div>
                      <label>Update Bid Price</label>
                      <ReduxFormButtonGroup
                        options={yesNoOptions}
                        type={'button'}
                        formName={IMPORT_ITEMS_FORM_NAME}
                        fieldName={ImportExportItemsEnum.ImportBidPrice}
                        onChange={onChangeOfBidPrice}
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
                {importBidPrice && (
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <Field
                        component={DatePickerField}
                        label={'Bid Date Begin'}
                        dateFormat={DATE_FORMAT_FOR_UI}
                        name={ImportExportItemsEnum.BeginDT}
                        onChange={onChangeOfFromDT}
                        maxDate={fromDateMax}
                        type={'text'}
                        dropdownMode="select"
                        customInput={<DatePickerCustomButton />}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        component={DatePickerField}
                        label={'Bid Date End'}
                        dateFormat={DATE_FORMAT_FOR_UI}
                        name={ImportExportItemsEnum.EndDT}
                        onChange={onChangeOfToDT}
                        type={'text'}
                        minDate={toDateMin}
                        customInput={<DatePickerCustomButton />}
                      />
                    </Grid.Column>
                  </Grid.Row>
                )}
              </Grid>
            </TitledCard>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {!!importItemsErrors.length && (
        <ApiResultMessage result={importItemsErrors} />
      )}
      <FileConfiguration
        handleFilePreview={handleFilePreview}
        displayDropZone={!importItemsData.length}
      />
      {!!importItemsData.length && (
        <div className="file-preview--header-wrapper">
          <Header content="Import Preview" floated="left" color="orange" />
          <Button
            className="file-preview--clear-mapping file-preview--header-button"
            size="tiny"
            onClick={clearMappingHandler}
            type={'button'}
          >
            Clear Mapping
          </Button>
          <Button
            className="file-preview--upload-new-file file-preview--header-button"
            size="tiny"
            onClick={uploadAnotherFileBtnClick}
            type={'button'}
          >
            Upload Another File
          </Button>
          <ImportFilePreview
            fileData={importItemsData}
            updatePreviewData={updatePreviewData}
            header={filterHeaderFields(columnMapping)}
            options={columns}
          />
        </div>
      )}
    </form>
  );
};
ImportItemsComponent.propTypes = {
  handleSubmit: PropTypes.func,
  onChangeImportType: PropTypes.func,
  onChangeConfig: PropTypes.func,
  importType: PropTypes.number,
  importBidPrice: PropTypes.bool,
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  toDateMin: PropTypes.object,
  importItemsErrors: PropTypes.array,
  importItemsData: PropTypes.array.isRequired,
  columnMapping: PropTypes.array,
  loadPreviousImportOptionsDropDown: PropTypes.array.isRequired,
  fromDateMax: PropTypes.object,
  handleFilePreview: PropTypes.func,
  columns: PropTypes.array,
  updatePreviewData: PropTypes.func,
  clearMappingHandler: PropTypes.func,
  uploadAnotherFileBtnClick: PropTypes.func,
  onChangeOfBidPrice: PropTypes.func,
};
export default ImportItemsComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/importInventory/components/ImportItems.js